// extracted by mini-css-extract-plugin
module.exports = {"ProPlanWrapper":"ProPlanBanner_ProPlanWrapper__fEyy6","Shadow":"ProPlanBanner_Shadow__ZGL_F"};